import { render, staticRenderFns } from "./IncomeDetails.vue?vue&type=template&id=53cdca18&scoped=true"
import script from "./IncomeDetails.vue?vue&type=script&lang=js"
export * from "./IncomeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cdca18",
  null
  
)

export default component.exports